module.exports = __webpack_public_path__ + "static/media/Stock-Footage-of-Shopping-for-Women-s-Clothing_libtheora.41f54673.ogv";